import React from "react";
import { CardBody } from "reactstrap";

export default function UserGuide({ stage }) {
  return (
    <div>
      <div className="card-heardere">
        <h4 className="bg-white text-center " style={{ borderRadius: 4 }}>
          User Guide
        </h4>
      </div>
      <CardBody style={{ height: "70vh", overflow: "auto" }} className="card">
        {stage === 1 ? (
          <ol>
            <li>
              This Dashboard shows the indicators averages for Sub-Saharan
              Africa region within selected year period.
            </li>
            <li>
              You can use the date range to specify different period for the
              averages
            </li>
            <li>
              Clicked on any of indicators to get the different country across
              Sub-Saharan Africa.
            </li>
          </ol>
        ) : (
          <ol>
            <li>
              This Dashboard shows country wise averages for selected indicator
              within selected year period.
            </li>
            <li>
              You can use the date range to specify different period for the
              averages
            </li>
            <li>Use indicator selector to choose different indicator</li>
            <li>Use country selector to choose specific country</li>
            <li>Select 'Regional Outlook' for all countries outlook</li>
          </ol>
        )}
      </CardBody>
    </div>
  );
}
